var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"list",attrs:{"row":""}},[_c('v-flex',{attrs:{"grow":""}},[_vm._t("item")],2),_c('v-flex',{attrs:{"shrink":""}},[_vm._t("info-card")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }